<template>
  <div>
    <el-form :inline="true">
    <dialogPanel>
      <HelpIdBar :helpId="SpecialChildData.specialPatientId" :apprStatusText="SpecialChildData.apprStatus == 5 ? '审核中' : SpecialChildData.apprStatusText "></HelpIdBar>
      <el-row>
        <el-col :md="6">
          <el-form-item label="患儿姓名">
            <el-input size="mini" type="text" disabled v-model="SpecialChildData.childName"></el-input>
          </el-form-item>
        </el-col>
        <el-col :md="6">
          <el-form-item label="患儿编号">
            <el-input size="mini" type="text" disabled v-model="SpecialChildData.childId"></el-input>
          </el-form-item>
        </el-col>
        <el-col :md="6">
          <el-form-item label="出生日期">
            <el-input size="mini" type="text" disabled v-model="birthday"></el-input>
          </el-form-item>
        </el-col>
        <el-col :md="6">
          <el-form-item label="身份证号">
            <el-input v-if="SpecialChildData.hasIdNumber" size="mini" type="text" disabled
              v-model="SpecialChildData.idNumber"></el-input>
            <el-input v-else size="mini" type="text" disabled value="-"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :md="6">
          <el-form-item label="救助医院">
            <el-input size="mini" type="text" disabled v-model="SpecialChildData.hospitalName"></el-input>
          </el-form-item>
        </el-col>
        <el-col :md="12">
          <el-form-item label="病 种">
            <el-input size="mini" type="text" disabled v-model="diseasesName"></el-input>
          </el-form-item>
        </el-col>
        <el-col :md="6">
          <el-form-item label="申请编号">
            <el-input size="mini" type="text" disabled v-model="SpecialChildData.helpId"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :md="6">
          <el-form-item label="申请类型">
            <el-radio-group size="mini" v-model="SpecialChildData.reqType"
              :disabled="SpecialChildData.apprStatus != 4">
              <el-radio label="1">提升治疗资助</el-radio>
              <el-radio label="2">检查费用资助</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :md="6">
          <el-form-item label="申请金额">
            <el-input size="mini" type="text" disabled v-model="SpecialChildData.reqAmount"
              :disabled="SpecialChildData.apprStatus != 4"></el-input>
          </el-form-item>
        </el-col>
        <el-col :md="6">
          <el-form-item label="特殊类型">
            <el-radio-group size="mini" v-model="SpecialChildData.specialType"
              :disabled="SpecialChildData.apprStatus != 4">
              <el-radio label="1">家庭特殊</el-radio>
              <el-radio label="2">病种特殊</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :md="12">
          <el-form-item label="申请理由">
            <el-input size="mini" type="textarea" :rows="3" disabled v-model="SpecialChildData.reqCause"
              :disabled="SpecialChildData.apprStatus != 4"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :md="12">
          <el-form-item label="备 注">
            <el-input size="mini" type="textarea" :rows="3" disabled v-model="SpecialChildData.reqRemark"
              :disabled="SpecialChildData.apprStatus != 4"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :md="24">
          <el-form-item label="附 件">
            <FileUpload :value="[SpecialChildData.attach]" :disabled="SpecialChildData.apprStatus != 4"></FileUpload>
          </el-form-item>
        </el-col>
      </el-row>
    </dialogPanel>
    <el-collapse :value="['1']" >
      <MyCollapse title="辅助信息" iconPath="/static/de-zmr.png"  name="1">
        <el-row>
          <el-col :md="6">
            <el-form-item label="申请时间">
              <el-date-picker size="mini" v-model="SpecialChildData.reqTime" align="right" type="date"
                value-format="yyyy-MM-dd" placeholder="申请时间" disabled>
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :md="6">
            <el-form-item label="审核时间">
              <el-date-picker size="mini" v-model="SpecialChildData.apprTime" align="right" type="date"
                value-format="yyyy-MM-dd" placeholder="申请时间" disabled>
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </MyCollapse>
    </el-collapse>
    </el-form>
    </div>
</template>

<script>
import { parseTime} from "../../../util/common";
import {
    getSpecialChildDataByIdApi,
    specialChildSubmitSpecialApi
  } from "@/util/api";
  import FileUpload from "@/components/business/FileUpload";
  import HelpIdBar from "@/components/business/HelpIdBar";
  import ChapterHead from "@/components/business/ChapterHead";
  import dialogPanel from "@/components/business/dialogPanel";
  import MyCollapse from "@/components/business/MyCollapse";
  export default {
    props: {
      specialPatientId: null,
    },
    components: {
      FileUpload,
      HelpIdBar,
      dialogPanel,
      MyCollapse,
      ChapterHead
    },
    data() {
      return {
        SpecialChildData: [],
        diseasesName: '',
        birthday: ''
      }
    },
    created() {
      this.getSpecialChildDataById()
    },
    methods: {
      submit() {
        let params = {
          "helpId": this.helpId, //救助编号
          "reqType": this.SpecialChildData.reqType, //申请类型
          "reqAmount": this.SpecialChildData.helpQuota, //申请金额
          "specialType": this.SpecialChildData.specialType, //特殊类型
          "reqCause": this.SpecialChildData.reqCause, //申请理由
          "reqRemark": this.SpecialChildData.reqRemark, //申请备注
          "attach": null, //附件
        }
        specialChildSubmitSpecialApi(params).then(res => {
          if (res.msgCode == 200) {
            this.$message.success(res.msg)
            this.newDialog = false
          } else {
            this.$message.error(res.msg)
          }
        }).catch()
      },
      // 按ID查询特殊患儿审核详情
      getSpecialChildDataById() {
        let params = {
          specialPatientId: this.specialPatientId
        }
        getSpecialChildDataByIdApi(params).then(res => {
          if (res.msgCode == 200) {
            // console.log(parseTime,123123)
            this.SpecialChildData = res.responseData
            this.birthday = parseTime(this.SpecialChildData.birthday, '{y}-{m}-{d}')
            this.SpecialChildData.reqTime = parseTime(this.SpecialChildData.reqTime, '{y}-{m}-{d}')
            this.SpecialChildData.apprTime = parseTime(this.SpecialChildData.apprTime, '{y}-{m}-{d}')
            for (var i = 0; i < res.responseData.diseasesList.length; i++) {
              this.diseasesName = res.responseData.diseasesList[i].diseasesName + this.diseasesName
            }
          }
        }).catch()
      },
    }
  }
</script>

<style lang="scss" scoped>
  @import "src/common/common";
  @import "src/common/form";
  .status{
    display: flex;
    align-items: center;
    img{
      width: 20px;
      margin-left: 10px;
      height: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/special/manage/especiallyDetail.vue